import FormatCurrency from 'components/Common/FormatCurrency/FormatCurrency'
import Modal from 'components/Luxkit/Modal/Modal'
import BodyText from 'components/Luxkit/Typography/BodyText'
import React from 'react'

type Props = {
  budget?: number
}

function BusinessTravellerFlightCreditsUnderBudgetInfoModal({ budget }: Props) {
  return <Modal title="Within budget">
    <BodyText variant="large">
      This offer is within the set budget
      {budget !== undefined && ' of '}
      {budget !== undefined && <FormatCurrency value={budget} />}.{' '}
    </BodyText>
  </Modal>
}

export default BusinessTravellerFlightCreditsUnderBudgetInfoModal
